import { AppThunkAction } from '../reducers';
import { ErrorType } from '../../models/HttpError';
import { ConceptCategory } from '../../models/Entities/Contracts/ConceptCategory';
import { NewConceptCategory } from '../../models/Entities/Contracts/NewConceptCategory';

// services
import * as Services from '../../services/ConceptCategory.Services';

// actions
import * as Actions from '../actions/ConceptCategory.Actions';

type KnownAction =
  | Actions.ConceptCategoryGetAllRequestAction
  | Actions.ConceptCategoryGetAllReceiveAction
  | Actions.ConceptCategoryGetAllFailAction
  | Actions.ConceptCategoryGetByIdRequestAction
  | Actions.ConceptCategoryGetByIdReceiveAction
  | Actions.ConceptCategoryGetByIdFailAction
  | Actions.ConceptCategoryAddRequestAction
  | Actions.ConceptCategoryAddReceiveAction
  | Actions.ConceptCategoryAddFailAction
  | Actions.ConceptCategoryUpdateRequestAction
  | Actions.ConceptCategoryUpdateReceiveAction
  | Actions.ConceptCategoryUpdateFailAction
  | Actions.ConceptCategoryDeleteRequestAction
  | Actions.ConceptCategoryDeleteReceiveAction
  | Actions.ConceptCategoryDeleteFailAction;

export const actionCreators = {
  GetAllConceptCategories: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
    const state = getState();
    if (state.ConceptCategories?.isLoadingAll || state.ConceptCategories?.successLoadingAll) return;

    dispatch({ type: 'CONCEPT_CATEGORY_GET_ALL_REQUEST_ACTION' });

    Services.GetAllConceptCategories()
      .then((conceptCategories: ConceptCategory[]) => {
        dispatch({
          type: 'CONCEPT_CATEGORY_GET_ALL_RECEIVE_ACTION',
          conceptCategories
        });
      })
      .catch((error: ErrorType) =>
        dispatch({
          type: 'CONCEPT_CATEGORY_GET_ALL_FAIL_ACTION',
          error
        })
      );
  },

  GetConceptCategoryById:
    (conceptCategoryId: number): AppThunkAction<KnownAction> =>
    async (dispatch) => {
      dispatch({
        type: 'CONCEPT_CATEGORY_GET_BY_ID_REQUEST_ACTION',
        conceptCategoryId
      });

      Services.GetConceptCategoryById(conceptCategoryId)
        .then((conceptCategory: ConceptCategory) => {
          dispatch({
            type: 'CONCEPT_CATEGORY_GET_BY_ID_RECEIVE_ACTION',
            conceptCategory
          });
        })
        .catch((error: ErrorType) =>
          dispatch({
            type: 'CONCEPT_CATEGORY_GET_BY_ID_FAIL_ACTION',
            error
          })
        );
    },

  AddConceptCategory:
    (newConceptCategory: NewConceptCategory): AppThunkAction<KnownAction> =>
    async (dispatch) => {
      dispatch({
        type: 'CONCEPT_CATEGORY_ADD_REQUEST_ACTION',
        newConceptCategory
      });

      Services.CreateConceptCategory(newConceptCategory)
        .then((conceptCategory: ConceptCategory) => {
          dispatch({
            type: 'CONCEPT_CATEGORY_ADD_RECEIVE_ACTION',
            conceptCategory
          });
        })
        .catch((error: ErrorType) =>
          dispatch({
            type: 'CONCEPT_CATEGORY_ADD_FAIL_ACTION',
            error
          })
        );
    },

  UpdateConceptCategory:
    (conceptCategory: ConceptCategory): AppThunkAction<KnownAction> =>
    async (dispatch) => {
      dispatch({
        type: 'CONCEPT_CATEGORY_UPDATE_REQUEST_ACTION',
        conceptCategory
      });

      Services.UpdateConceptCategory(conceptCategory)
        .then((updated: ConceptCategory) => {
          dispatch({
            type: 'CONCEPT_CATEGORY_UPDATE_RECEIVE_ACTION',
            conceptCategory: updated
          });
        })
        .catch((error: ErrorType) =>
          dispatch({
            type: 'CONCEPT_CATEGORY_UPDATE_FAIL_ACTION',
            error
          })
        );
    },

  DeleteConceptCategory:
    (conceptCategoryId: number): AppThunkAction<KnownAction> =>
    async (dispatch) => {
      dispatch({
        type: 'CONCEPT_CATEGORY_DELETE_REQUEST_ACTION',
        conceptCategoryId
      });

      Services.DeleteConceptCategory(conceptCategoryId)
        .then(() => {
          dispatch({
            type: 'CONCEPT_CATEGORY_DELETE_RECEIVE_ACTION',
            conceptCategoryId
          });
        })
        .catch((error: ErrorType) =>
          dispatch({
            type: 'CONCEPT_CATEGORY_DELETE_FAIL_ACTION',
            error
          })
        );
    }
};
